/**
 * Mobile Menu Drill-Down Navigation
 * Maneja la funcionalidad drill-down en el menú móvil
 */

class MobileMenuDrillDown {
  constructor() {
    this.mobileMenu = document.querySelector('.mobile-menu');
    this.navigationStack = [];
    this.init();
  }

  init() {
    if (!this.mobileMenu) return;

    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    // Event delegation para manejar clics en enlaces con hijos
    this.mobileMenu.addEventListener('click', (e) => {
      const link = e.target.closest('[data-has-children]');
      if (link) {
        e.preventDefault();
        const submenuId = link.getAttribute('data-submenu');
        const title = link.querySelector('.mobile-menu__text').textContent;
        this.navigateToSubmenu(submenuId, title);
      }

      // Manejar botones de regreso
      const backButton = e.target.closest('[data-back]');
      if (backButton) {
        e.preventDefault();
        this.navigateBack();
      }
    });

    // Resetear cuando se cierra el menú móvil
    const menuOverlay = document.getElementById('mobile-menu-overlay');
    if (menuOverlay) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const isOpen = menuOverlay.getAttribute('aria-hidden') === 'false';
            if (!isOpen) {
              this.reset();
            }
          }
        });
      });
      
      observer.observe(menuOverlay, { 
        attributes: true, 
        attributeFilter: ['aria-hidden'] 
      });
    }
  }

  setInitialState() {
    // Asegurar que todos los submenús estén ocultos al inicio
    const submenus = this.mobileMenu.querySelectorAll('.mobile-menu__submenu');
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
    });
    this.navigationStack = [];
  }

  navigateToSubmenu(submenuId, title) {
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    // Agregar al stack de navegación
    this.navigationStack.push({
      submenuId: submenuId,
      title: title
    });

    // Ocultar contenido principal si es el primer nivel
    if (this.navigationStack.length === 1) {
      const mainContent = this.mobileMenu.querySelector('.mobile-menu__main-content');
      if (mainContent) {
        mainContent.classList.add('hidden');
      }
    }

    // Ocultar menú actual si hay uno visible
    const currentMenu = this.getCurrentVisibleMenu();
    if (currentMenu) {
      currentMenu.classList.remove('active');
    }

    // Mostrar nuevo submenú
    submenu.classList.add('active');

    // Actualizar el título del header si existe
    const headerTitle = submenu.querySelector('.mobile-menu__submenu-title');
    if (headerTitle) {
      headerTitle.textContent = title;
    }
  }

  navigateBack() {
    if (this.navigationStack.length === 0) return;

    // Remover del stack
    this.navigationStack.pop();

    // Ocultar submenú actual
    const currentSubmenu = this.getCurrentVisibleMenu();
    if (currentSubmenu) {
      currentSubmenu.classList.remove('active');
    }

    // Mostrar menú anterior
    if (this.navigationStack.length > 0) {
      const previousMenu = this.navigationStack[this.navigationStack.length - 1];
      const previousSubmenu = document.getElementById(previousMenu.submenuId);
      if (previousSubmenu) {
        previousSubmenu.classList.add('active');
      }
    } else {
      // Volver al contenido principal
      const mainContent = this.mobileMenu.querySelector('.mobile-menu__main-content');
      if (mainContent) {
        mainContent.classList.remove('hidden');
      }
    }
  }

  getCurrentVisibleMenu() {
    return this.mobileMenu.querySelector('.mobile-menu__submenu.active');
  }

  reset() {
    // Limpiar stack de navegación
    this.navigationStack = [];

    // Ocultar todos los submenús
    const submenus = this.mobileMenu.querySelectorAll('.mobile-menu__submenu');
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
    });

    // Mostrar contenido principal
    const mainContent = this.mobileMenu.querySelector('.mobile-menu__main-content');
    if (mainContent) {
      mainContent.classList.remove('hidden');
    }
  }

  // Método público para navegar programáticamente
  navigateTo(submenuId, title) {
    this.navigateToSubmenu(submenuId, title);
  }

  // Método público para volver al menú principal
  goToMainMenu() {
    this.reset();
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  window.mobileMenuDrillDown = new MobileMenuDrillDown();
});

// Exportar para uso en otros scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = MobileMenuDrillDown;
}